import { createFileRoute } from "@tanstack/react-router";
import { LegalSection } from "@/components/legal/legal-section";

export const Route = createFileRoute("/legal/")({
	component: LegalSection,
});
